import { InstaMediaType } from '../../react-pages/ServicePage/WorkshopPhotos/types';
import { IAction } from '../utils';
import { reducerTypes } from './types';

export const INITIAL: InstaMediaType[] = [];

export const instaMediaReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.GET_ALL_INSTA_MEDIA:
      return payload;
    default:
      return state;
  }
};
